import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import { saveTripRequest, saveTripSuccess, saveTripFailure } from '../../slices/trip';
import formatTripRequest from '../../../helpers/formatTripRequest';
import setURLParams from '../../../utils/setURLParams';
import getFiltersFromTrip from '../../../helpers/getFiltersFromTrip';
import { setCruiseSearchInputs, setCruiseSearchParam } from '../../slices/tripSearch';

function* getBrochureData() {
  try {
    const isBrochurePage = window && window.location && window.location.pathname && window.location.pathname.indexOf('brochure') > -1;
    if (isBrochurePage) {
      const queryParams = new URLSearchParams(window.location.search);
      const brochuresId = queryParams.get('id');
      const brochure = yield select((store) => store.brochure.brochures[brochuresId]);

      if (brochure) {
        return {
          advisorEmail: brochure.loggedInUserEmail,
          brochureId: brochure.id,
          isBrochurePage,
        };
      }
    }
  } catch (error) {
    // Handle error if needed
    console.error('Error getting brochure data:', error);
  }
  return { advisorEmail: undefined, brochureId: undefined };
}

function* saveTripWorker({
  payload: {
    tripId,
    trip,
    tripRoomSearchInput,
  },
}) {
  try {
    const selectedSearchMode = yield select((store) => store.tripSearch.selectedSearchMode);
    const searchObj = yield select((store) => store.tripSearch.searchObj);
    const { filters } = searchObj.cruise;
    const resultsPageUrl = setURLParams({ searchObj, searchedMode: selectedSearchMode });
    const { advisorEmail, brochureId, isBrochurePage } = yield call(getBrochureData);

    const url = isBrochurePage ? '/trips/save/brochure' : '/trips/save';
    const config = {
      method: 'post',
      url,
      data: JSON.stringify(formatTripRequest({
        trip: {
          ...trip,
          advisorEmail,
          brochureId,
          resultsPageUrl,
        },
        ...filters,
        staterooms: searchObj.staterooms,
        isBrochurePage,
        tripRoomSearchInput,
      })),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    if (!data) {
      throw new Error();
    }
    if (isBrochurePage) {
      const searchObject = {
        filters: getFiltersFromTrip(data.trip),
        staterooms: getFiltersFromTrip(data.trip).staterooms,
      };
      yield put(setCruiseSearchParam(searchObject));
      yield put(setCruiseSearchInputs(searchObject));
    }

    yield put(saveTripSuccess({
      tripId,
      trip: {
        ...(data.trip || {}),
        maxCharsHotelSpecialRequest: (data || {}).maxCharsHotelSpecialRequest,
        maxCharsNoteToAirDesk: (data || {}).maxCharsNoteToAirDesk,
        doShowNoteToAirDeskInput: (data || {}).doShowNoteToAirDeskInput,
        doShowCompanyNameInput: (data || {}).doShowCompanyNameInput,
        doShowAgencyPlanningFeesPerPassenger: (data || {}).doShowAgencyPlanningFeesPerPassenger,
        separatePnrForTravelTypes: (data || {}).separatePnrForTravelTypes,
        doSupportsCardUpsertOperations: (data || {}).doSupportsCardUpsertOperations,
        tripBookingFees: data && data.tripBookingFees,
      },
    }));
  } catch (error) {
    let errorMsg = 'Error in save your changes, please try again.';
    if (error && error.response && error.response.data) {
      errorMsg = `${error.response.data.title} ${error.response.data.detail}`;
    } else if (error && typeof (error) === 'object' && error.message) {
      errorMsg = `Error in save your changes. ${error.name}: ${error.message} (${error.code}).`;
    }
    yield put(saveTripFailure({ error: errorMsg, tripId }));
  }
}

function* tripSaveWatcher() {
  yield takeLatest(saveTripRequest.toString(), saveTripWorker);
}

export default tripSaveWatcher;
